export default [
  {
    name: 'esqueci-senha-externo',
    path: '/portal-cliente/esqueci-senha-externo',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/app-modulo/documento/esqueci-senha-externo/EsqueciSenhaExterno.vue'),
    meta: {
      requiredAuth: false,
      layout: 'full',
    },
  },
]
